import script from "./MiningInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MiningInfo.vue?vue&type=script&setup=true&lang=js"

import "./MiningInfo.vue?vue&type=style&index=0&id=6c14f6d2&lang=scss"

const __exports__ = script;

export default __exports__